module.exports = __webpack_public_path__ + "img/lookbook_2_left.758ebc02.png";